/**
 * "Open the message in context" (Activity → channel or thread): after the route opens, waits for the message row
 * (`data-testid="message-<id>"`, packages/ui MessageRow) to render, scrolls it to the middle and flashes it. Gives up
 * quietly after a few seconds (the message may be further back than the first page loads).
 */
const TIMEOUT_MS = 4000;

export function focusMessage(messageId: string): void {
  const started = performance.now();
  const selector = `[data-testid="message-${CSS.escape(messageId)}"]`;
  const tick = () => {
    const rows = document.querySelectorAll<HTMLElement>(selector);
    // The newest pane wins when the same conversation is open twice.
    const el = rows[rows.length - 1];
    if (el !== undefined) {
      el.scrollIntoView({ block: "center", behavior: "smooth" });
      el.classList.remove("message-focus");
      void el.offsetWidth; // restart the animation
      el.classList.add("message-focus");
      window.setTimeout(() => el.classList.remove("message-focus"), 2400);
      return;
    }
    if (performance.now() - started < TIMEOUT_MS) window.setTimeout(tick, 100);
  };
  window.setTimeout(tick, 50);
}
